import { Vector3, Color4, Vector2, Scene, ArcRotateCamera, Matrix, AbstractMesh, Quaternion } from '@babylonjs/core';
import { Vector } from '../../utils/Vector';
import { Ellipse, AdvancedDynamicTexture, Control, Rectangle, Image, StackPanel } from '@babylonjs/gui';
import { Player } from '../player/Player';
import { GlobalObject } from '../../utils/GlobalObject';

export class NaviMinimap {
    private scene: Scene;
    private camera: ArcRotateCamera;
    private static _instance: NaviMinimap;
    private gui: AdvancedDynamicTexture;
    private mc?: Rectangle;
    private pt?: Image;
    private northDir?: Image;
    private map?: Image;
    private playerObj?: Player;
    private player: AbstractMesh;
    private source?: any;
    private isShow = true;
    private mat = Matrix.Identity(); // identity matrix 单位矩阵; reset是所有元素重置为0
    private oldX = -1000;
    private oldZ = -1000;


    constructor(scene: Scene, camera: ArcRotateCamera) {
        this.scene = scene;
        this.camera = camera;
        let gui = GlobalObject.getInstance().main.gui;
        if (gui) {
            this.gui = gui;
        } else {
            this.gui = AdvancedDynamicTexture.CreateFullscreenUI("UI");
            this.gui.idealWidth = 1000;
        }
        this.playerObj = GlobalObject.getInstance().main.player;
        this.player = this.playerObj?.player as AbstractMesh;
        this.source = GlobalObject.getInstance().main.source.common;
        this.initUI();
    }
    public static getInstance(scene?: Scene, camera?: ArcRotateCamera) {
        if (!this._instance) this._instance = new NaviMinimap(scene as Scene, camera as ArcRotateCamera);
        return this._instance;
    }
    private initUI() {
        this.mc = new Rectangle();
        // 左下角
        this.mc.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.mc.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        this.mc.width = "108px";
        this.mc.height = "108px";
        this.mc.top = "-42px";
        this.mc.left = "200px";
        this.mc.color = "#ffcc0000";
        this.gui.addControl(this.mc);
        //this.mc.isPointerBlocker = true;  // 允许鼠标交互

        let image = new Image("bg", this.source.naviBg);
        image.width = "108px";
        image.height = "108px";
        image.top = 0;
        image.left = 0;
        this.mc.addControl(image);

        this.pt = new Image("navi_point", this.source.pt);
        this.pt.width = "18px";
        this.pt.height = "18px";
        this.pt.top = 0;
        this.pt.left = 0;
        this.mc.addControl(this.pt);

        this.northDir = new Image("north_direction", this.source.nDir);
        this.northDir.width = "8px";
        this.northDir.height = "9.6px";
        this.northDir.top = -40;
        this.northDir.left = -40;
        this.mc.addControl(this.northDir);
        this.hide();

        //this.loadImg();
    }
    public loadImg(url: string = '', rect3D: any = {}, rectMap: any = {}) {
        //rect3D = { start: new Vector3(70, 0, -23), end: new Vector3(-125, 0, 68), rangeX: -197, rangeZ: 91 }; // (x+)-(x-); (z+)-(z-)
        //rectMap = { start: new Vector3(0 - 50, 0, 26 - 50), end: new Vector3(100 - 50, 0, 73 - 50), rangeX: 100, rangeZ: 47 }; // top和left的原点在mc的矩形中心
        this.mat = this.getMatrix(rect3D, rectMap);
        this.mc?.removeControl(this.pt as Image);
        if (this.map) {
            this.map.source = url;
            this.mc?.removeControl(this.map);
        } else {
            this.map = new Image("map", url);
        }
        this.map.width = "100px";
        this.map.height = "100px";
        this.map.top = 0;
        this.map.left = 0;
        this.mc?.addControl(this.map);
        this.mc?.addControl(this.pt as Image);
        this.mc?.removeControl(this.northDir as Image);
        this.mc?.addControl(this.northDir as Image);
        this.show();
        this.update();
    }

    // ----------------  用Matrix对象实现不同坐标系之间向量和坐标的转换 -----------------
    // 通过计算两个坐标系在X和Z轴上的缩放比例和偏移量,设置Matrix对象的值,实现了两个坐标系之间的转换关系。
    // 然后用Vector3.TransformCoordinates方法可以实现坐标的转换,如把rect3D坐标系下的(-75, 0, 58)转换到rectMap坐标系下
    private getMatrix(rect3D: { start: Vector3, end: Vector3, rangeX: number, rangeZ: number }, rectMap: { start: Vector3, end: Vector3, rangeX: number, rangeZ: number }) {
        // 创建一个Matrix对象
        let transformMatrix = new Matrix();

        // 计算两个坐标系在X和Z轴上的缩放比例
        let scaleX = rectMap.rangeX / rect3D.rangeX;
        let scaleZ = rectMap.rangeZ / rect3D.rangeZ;
        console.log(scaleX, scaleZ)

        // 计算两个坐标系在X和Z轴上的偏移量 
        let offsetX = rectMap.start.x - scaleX * rect3D.start.x;
        let offsetZ = rectMap.start.z - scaleZ * rect3D.start.z;

        // 设置Matrix对象的值
        let m = transformMatrix.m as number[];
        m[0] = scaleX;
        m[1] = 0;
        m[2] = 0;
        m[3] = 0;

        m[4] = 0;
        m[5] = 1;
        m[6] = 0;
        m[7] = 0;

        m[8] = 0;
        m[9] = 0;
        m[10] = scaleZ;
        m[11] = 0;

        m[12] = offsetX;
        m[13] = 0;
        m[14] = offsetZ;
        m[15] = 1;
        return transformMatrix;
    }
    // 使用Quaternion类来实现右手坐标系和左手坐标系之间旋转值的转换。
    private invertRotation(angle: number) {
        var q = Quaternion.RotationYawPitchRoll(angle, 0, 0); // y,x,z
        // 克隆
        var q2 = q.clone();
        // 求逆到左手坐标系
        q2.invert();
        //q2现在就是一个左手坐标系下绕Y轴旋转45度的Quaternion
        // 从Quaternion提取Euler角
        var eulerAngles = q2.toEulerAngles();
        // eulerAngles现在包含左手坐标系下的yaw、pitch、roll
        var yaw = eulerAngles.y;
        var pitch = eulerAngles.x;
        var roll = eulerAngles.z;
        console.log("Yaw: " + yaw + " Pitch: " + pitch + " Roll: " + roll);
        return yaw;
    }
    public update() {
        this.scene.registerBeforeRender(() => {
            if (this.isShow) {
                let pt = this.pt as Image;
                pt.rotation = (this.camera.alpha || 0) * -1; // 右手系的旋转值转左手系旋转值需要*-1;
                let pos = this.player.position.clone();
                let res = Vector3.TransformCoordinates(pos, this.mat);
                pt.left = res.x;
                pt.top = res.z;
            }
        })
    }
    public hide() {
        this.isShow = false;
        (this.mc as Rectangle).isVisible = false;
        console.log('hide mini map');
    }
    public show() {
        this.isShow = true;
        (this.mc as Rectangle).isVisible = true;
    }
}